<div class="container">
  <div class="row">
    <div class="col-12 col-lg-6 pb-3 pb-lg-0 d-print-none d-flex justify-content-center justify-content-lg-start">
      <wfp-logo></wfp-logo>
    </div>
    @if (headerInfo$ | async; as headerInfo) {
      <div class="col-12 col-lg-6">
        <div class="alert alert-warning py-4">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <div
                class="signedIn"
                [class.mb-3]="!headerInfo.isPatientLogin">
                @if (!headerInfo.isAgentLogin) {
                  {{ 'default.signedInAs' + (headerInfo.isPatientLogin ? '' : '.related') | translate }}
                }
                @if (headerInfo.isAgentLogin) {
                  {{ 'default.signedInAs.agent' | translate }}
                }
                @if (!headerInfo.isPatientLogin) {
                  <br />
                }
                <strong>{{ headerInfo.patientName }}</strong>
              </div>
              <div>
                <span>
                  <i
                    aria-label="Vårdverksamhet"
                    id="hospis"
                    class="fa-regular fa-hospital"></i>
                </span>
                <span class="px-3">{{ headerInfo.careUnitName }}</span>
              </div>
            </div>
            <div>
              @if (!headerInfo.isActiveForm) {
                <wfs-form-button
                  (buttonClicked)="logout()"
                  [label]="'shared.logout' | translate"
                  [buttonStyle]="headerInfo.logoutButtonGreen ? 'primary' : 'warning'" />
              }
              @if (headerInfo.isActiveForm) {
                <div class="empty-logout-height"></div>
              }
            </div>
          </div>
          @if (headerInfo.isIneraLogin) {
            <div class="d-flex justify-content-end pt-3">
              @if (!headerInfo.isActiveForm) {
                <a
                  tabindex="0"
                  class="btn-link"
                  href
                  (click)="returnToExternalSite(headerInfo.returnUrl)">
                  {{ 'shared.backToVardguiden' | translate }}
                </a>
              }
              @if (headerInfo.isActiveForm) {
                <div class="empty-inera-link-height"></div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
  <div class="d-flex justify-content-end pb-3 d-print-none">
    <wfp-language-picker></wfp-language-picker>
  </div>
</div>
